<template>
  <div>
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <v-card :loading="isLoading" id="account-setting-card">
      <v-card-title>
        <span v-if="user != null" class="me-3">{{ user.name }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{ $t('pages.back') }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <!--      <div v-if="userType == 'admin' || userType == 'school'">-->
      <div>
        <!-- tabs -->
        <v-tabs v-model="tab" show-arrows>
          <v-tab v-for="tab in tabs" :key="tab.icon">
            <v-icon size="20" class="me-3">
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>
        </v-tabs>
        <!-- tabs item -->
        <v-tabs-items touchless v-model="tab">
          <v-tab-item>
            <account-settings-account
              :account-data="user"
              :user-type="userType"
              @save-user-info="saveUser"
            ></account-settings-account>
          </v-tab-item>

          <v-tab-item>
            <account-settings-security
              @save-user-password="savePassword"
            ></account-settings-security>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <!--      <div v-else>-->
      <!--        <account-settings-account-->
      <!--          :account-data="user"-->
      <!--          :user-type="userType"-->
      <!--          @save-user-info="saveUser"-->
      <!--        ></account-settings-account>-->
      <!--      </div>-->
    </v-card>
  </div>
</template>

<script>
import { mdiAccountOutline, mdiLockOpenOutline } from '@mdi/js';
import { ref } from '@vue/composition-api';
import AccountSettingsAccount from './user-settings/AccountSettingsAccount.vue';
import AccountSettingsSecurity from './user-settings/AccountSettingsSecurity.vue';
import VueElementLoading from 'vue-element-loading';
import { adminProfileStore } from '@/utils/helpers';

export default {
  components: {
    AccountSettingsAccount,
    AccountSettingsSecurity,
    VueElementLoading,
  },
  setup() {
    return { adminProfileStore };
  },
  data() {
    return {
      isLoading: false,
      user_id: null,
      userType: null,
      user: null,
      edit: false,
      tabs: [
        { title: this.$t('pages.account'), icon: mdiAccountOutline },
        { title: this.$t('pages.change_password'), icon: mdiLockOpenOutline },
      ],
      tab: ref(''),
    };
  },
  watch: {
    $route(to, from) {
      this.onRouteChanged();
    },
  },
  mounted() {
    this.onRouteChanged();
  },
  methods: {
    onRouteChanged() {
      if (this.$route.params.user_id != null) {
        this.user_id = this.$route.params.user_id;
        this.userType = this.$route.name.split('-')[1];
        if (this.userType === 'organisation') {
          this.userType = 'school';
        }
        this.fetchUser();
      }
    },
    //API Calls
    fetchUser() {
      this.isLoading = true;
      axios
        .get(`/users/${this.userType}`, {
          params: {
            user_id: this.user_id,
          },
        })
        .then((response) => {
          this.isLoading = false;
          this.user = response.data;
          // this.user.parent_id = response.data?.guardians?.[0]?.id;
          this.user.parent_ids = response.data?.guardians?.map(({ id }) => id);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_fetching_user_data'),
            type: 'error',
          });
          this.$router.go(-1);
        });
    },
    saveUser() {
      this.isLoading = true;
      axios
        .post(`/users/${this.userType}-edit`, {
          user: this.user,
        })
        .then(() => {
          if (this.userType == 'admin' || this.userType == 'school') {
            adminProfileStore.name = this.user.name;
            adminProfileStore.avatar = this.user.avatar;
          }
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.user_updated'),
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.saveErrorText(error),
            type: 'error',
          });
        });
    },
    // Serveri e di pse deshtoi; pa kete, cdo shkak dukej njesoj.
    saveErrorText(error) {
      const data = error.response && error.response.data;
      if (data && data.reason === 'email_taken') {
        return this.$t('messages.email_already_used');
      }
      return (data && data.message) || this.$t('messages.error_updating_user');
    },
    savePassword(password) {
      this.isLoading = true;
      axios
        .post('/users/update-password', {
          user_id: this.user.id,
          password: password,
        })
        .then(() => {
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.user_updated'),
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.isLoading = false;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_updating_user'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        });
    },
  },
};
</script>
